import { IBackStory } from "@src/components/Backstory";
import image from "../../../../public/images/t3-demo-1.jpg";
import React from "react";
import Image from "next/image";
import { truncate } from "lodash";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import DialogModal from "@src/components/Dialog";
import BackstoryModal from "@src/components/modals/BackstoryModal";
import { getRole } from "@src/utils/general";

const Backstory: React.FC<IBackStory> = ({ eventId, backStoryData }) => {
  return (backStoryData?.getBackStory ?? []).length > 0 ? (
    <section className="w-full py-16 md:py-24 bg-[#60535A]">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-4">
          <h2 className="font-nib text-4xl md:text-5xl font-light text-white mb-12">
            Our Story
          </h2>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {backStoryData?.getBackStory?.map((story, idx) => (
            <div key={idx} className="flex flex-col items-center">
              {/* Image */}
              <div className="w-64 h-80 mb-2 rounded-lg overflow-hidden bg-gray-300 relative">
                <Image
                  placeholder="blur"
                  loading="eager"
                  layout="fill"
                  blurDataURL={`data:image/svg+xml;base64,${toBase64(
                    shimmer(700, 475)
                  )}`}
                  src={story?.image || image}
                  alt={story?.title || "Wedding photo"}
                  className="object-cover"
                  sizes="(max-width: 768px) 100vw, 320px"
                />
              </div>

              {/* Title */}
              <h3 className="text-white text-md font-normal tracking-widest mb-2 text-center">
                {story?.title || "Our Story"}
              </h3>

              <p className="text-white text-base font-normal font-ebGaramond leading-relaxed text-center max-w-sm mb-4">
                {truncate(story?.story, {
                  length: 300,
                }) || "Our love story begins here..."}
              </p>
              <p className="text-white text-md font-normal tracking-widest mb-2 text-center">
                {getRole(story?.role)}
              </p>

              <DialogModal
                trigger={
                  <button className="border border-white text-white px-6 py-2 text-sm tracking-wider font-ebGaramond hover:bg-white hover:text-[#60535A] transition-colors duration-300 rounded-2xl">
                    CONTINUE READING
                  </button>
                }
              >
                <BackstoryModal
                  title={story?.title ?? ""}
                  story={story?.story ?? ""}
                  role={getRole(story?.role) ?? ""}
                />
              </DialogModal>
            </div>
          ))}
        </div>
      </div>
    </section>
  ) : (
    <></>
  );
};

export default Backstory;
